const translations = {
    "British English": {
        "scale_text": "SCALE 1:1 OF",
        "date_format": "[day] [month] [year]",
        "months": ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
        "length_unit": "CENTIMETRES",
        "weight_unit": "GRAMS",
        "default_unit": "metrics",
        "iso_code": "en-gb",
        "dont_show_length": "Do not show length",
        "stars_over": "THE STARS ABOVE",
	    "location_search": "SEARCH"
	},
    "American English": {
        "scale_text": "SCALE 1:1 OF",
        "date_format": "[month] [day], [year]",
        "months": ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
        "length_unit": "CENTIMETERS",
        "weight_unit": "GRAMS",
        "default_unit": "imperial",
        "iso_code": "en-us",
        "dont_show_length": "Do not show length",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Swedish": {
        "scale_text": "SKALA 1:1 AV",
        "date_format": "[day] [month] [year]",
        "months": ['JANUARI', 'FEBRUARI', 'MARS', 'APRIL', 'MAJ', 'JUNI', 'JULI', 'AUGUSTI', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DECEMBER'],
        "length_unit": "CENTIMETER",
        "weight_unit": "GRAM",
        "default_unit": "metrics",
        "iso_code": "sv",
        "dont_show_length": "Visa inte längd",
        "stars_over": "STJÄRNORNA ÖVER",
		"location_search": "SÖKA"
	},
    "Bulgarian": {
        "scale_text": "PA3MEP 1:1 HA",
        "date_format": "[day] [month] [year] Г.",
        "months": ['ЯНУАРИ', 'ФЕВРУАРИ', 'MAPT', 'АПРИЛ', 'МАЙ', 'ЮНИ', 'ЮЛИ', 'АВГУСТ', 'СЕПТЕМВРИ', 'ОКТОМВРИ', 'НОЕМВРИ', 'ДЕКЕМВРИ'],
        "length_unit": "САНТИМЕТРА",
        "weight_unit": "ГРАМА",
        "default_unit": "metrics",
        "iso_code": "bg",
        "dont_show_length": "Не показвай дължината",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Danish": {
        "scale_text": "SKALA 1:1 AF",
        "date_format": "[day_formatted]. [month] [year]",
        "months": ['JANUAR', 'FEBRUAR', 'MARTS', 'APRIL', 'MAJ', 'JUNI', 'JULI', 'AUGUST', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DECEMBER'],
        "length_unit": "CENTIMETER",
        "weight_unit": "GRAM",
        "default_unit": "metrics",
        "iso_code": "da",
        "dont_show_length": "Vis ikke længde",
        "stars_over": "STJERNERNE OVER",
		"location_search": "SØGE"
	},
    "Norwegian": {
        "scale_text": "SKALA 1:1 AV",
        "date_format": "[day_formatted]. [month] [year]",
        "months": ['JANUAR', 'FEBRUAR', 'MARS', 'APRIL', 'MAI', 'JUNI', 'JULI', 'AUGUST', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DESEMBER'],
        "length_unit": "CENTIMETER",
        "weight_unit": "GRAM",
        "default_unit": "metrics",
        "iso_code": "no",
        "dont_show_length": "Ikke vis lengde",
        "stars_over": "STJERNENE OVER",
		"location_search": "SØK"
	},
    "Finnish": {
        "scale_text": "MITTAKAAVA 1:1",
        "date_format": "[day]. [month]TA [year]",
        "months": ['TAMMIKUU', 'HELMIKUU', 'MAALISKUU', 'HUHTIKUU', 'TOUKOKUU', 'KESÄKUU', 'HEINÄKUU', 'ELOKUU', 'SYYSKUU', 'LOKAKUU', 'MARRASKUU', 'JOULUKUU'],
        "length_unit": "SENTTIMETRIÄ",
        "weight_unit": "GRAMMAA",
        "default_unit": "metrics",
        "iso_code": "fi",
        "dont_show_length": "Älä näytä pituutta",
        "stars_over": "TÄHDET YLLÄ",
		"location_search": "SEARCH"
	},
    "Dutch": {
        "scale_text": "SCHAAL 1:1 VAN",
        "date_format": "[day] [month] [year]",
        "months": ['JANUARI', 'FEBRUARI', 'MAART', 'APRIL', 'MEI', 'JUNI', 'JULI', 'AUGUSTUS', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DECEMBER'],
        "length_unit": "CENTIMETER",
        "weight_unit": "GRAM",
        "default_unit": "metrics",
        "iso_code": "nl",
        "dont_show_length": "Lengte niet tonen",
        "stars_over": "DE STERREN BOVEN",
		"location_search": "SEARCH"
	},
    "Estonian": {
        "scale_text": "MÕÕTKAVA 1:1",
        "date_format": "[day]. [month] [year]",
        "months": ['JAANUAR', 'VEEBRUAR', 'MÄRTS', 'APRILL', 'MAI', 'JUUNI', 'JUULI', 'AUGUST', 'SEPTEMBER', 'OKTOOBER', 'NOVEMBER', 'DETSEMBER'],
        "length_unit": "SENTIMEETRIT",
        "weight_unit": "GRAMMI",
        "default_unit": "metrics",
        "iso_code": "et",
        "dont_show_length": "Ära näita sünnipikkust",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "French": {
        "scale_text": "ÉCHELLE 1:1 DE",
        "date_format": "[day] [month] [year]",
        "months": ['JANVIER', 'FÉVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN', 'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DÉCEMBRE'],
        "length_unit": "CENTIMÈTRES",
        "weight_unit": "GRAMMES",
        "default_unit": "metrics",
        "iso_code": "fr",
        "dont_show_length": "Ne pas afficher la longueur",
        "stars_over": "LES ÉTOILES AU-DESSUS DE",
		"location_search": "SEARCH"
	},
    "Turkish": {
        "scale_text": "1:1 ÖLÇEKLİ",
        "date_format": "[day] [month] [year]",
        "months": ['OCAK', 'ŞUBAT', 'MART', 'NİSAN', 'MAYIS', 'HAZİRAN', 'TEMMUZ', 'AĞUSTOS', 'EYLÜL', 'EKİM', 'KASIM', 'ARALIK'],
        "length_unit": "SANTİMETRE",
        "weight_unit": "GRAM",
        "default_unit": "metrics",
        "iso_code": "tr",
        "dont_show_length": "Doğum uzunluğunu gösterme",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Portuguese": {
        "scale_text": "ESCALA 1:1 DE",
        "date_format": "[day] DE [month] DE [year]",
        "months": ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'],
        "length_unit": "CENTÍMETROS",
        "weight_unit": "GRAMAS",
        "default_unit": "metrics",
        "iso_code": "pt",
        "dont_show_length": "Não mostrar comprimento",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Faroese": {
        "scale_text": "MÁT 1:1 AV",
        "date_format": "[day]. [month] [year]",
        "months": ['JANUAR', 'FEBRUAR', 'MARS', 'APRÍL', 'MAI', 'JUNI', 'JULI', 'AUGUST', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DESEMBER'],
        "length_unit": "SENTIMETRAR",
        "weight_unit": "GRAMM",
        "default_unit": "metrics",
        "iso_code": "fo",
        "dont_show_length": "Ikki vísa føðilongd",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Hungarian": {
        "scale_text": "1:1 ARÁNYÚ",
        "date_format": "[year]. [month] [day].",
        "months": ['JANUÁR', 'FEBRUÁR', 'MÁRCIUS', 'ÁPRILIS', 'MÁJUS', 'JÚNIUS', 'JÚLIUS', 'AUGUSZTUS', 'SZEPTEMBER', 'OKTÓBER', 'NOVEMBER', 'DECEMBER'],
        "length_unit": "CENTIMÉTER",
        "weight_unit": "GRAMM",
        "default_unit": "metrics",
        "iso_code": "hu",
        "dont_show_length": "Ne mutassa a születési hosszt",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Greek": {
        "scale_text": "ΚΛΙΜΑΚΑ 1:1 ΤΟΥ",
        "date_format": "[day] [month] [year]",
        "months": ['ΙΑΝΟΥΑΡΙΟΣ', 'ΦΕΒΡΟΥΑΡΙΟΣ', 'ΜΑΡΤΙΟΣ', 'ΑΠΡΙΛΙΟΣ', 'ΜΑΙΟΣ', 'ΙΟΥΝΙΟΣ', 'ΙΟΥΛΙΟΣ', 'ΑΥΓΟΥΣΤΟΣ', 'ΣΕΠΤΕΜΒΡΙΟΣ', 'ΟΚΤΩΒΡΙΟΣ', 'ΝΟΕΜΒΡΙΟΣ', 'ΔΕΚΕΜΒΡΙΟΣ'],
        "length_unit": "ΕΚΑΤΟΣΤΑ",
        "weight_unit": "ΓΡΑΜΜΑΡΙΑ",
        "default_unit": "metrics",
        "iso_code": "el",
        "dont_show_length": "Μην δείξετε μήκος",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Icelandic": {
        "scale_text": "SKALI 1:1",
        "date_format": "[day]. [month] [year]",
        "months": ['JANÚAR', 'FEBRÚAR', 'MARS', 'APRÍL', 'MAÍ', 'JÚNÍ', 'JÚLÍ', 'ÁGÚST', 'SEPTEMBER', 'OKTÓBER', 'NÓVEMBER', 'DESEMBER'],
        "length_unit": "SENTÍMETRAR",
        "weight_unit": "GRÖMM",
        "default_unit": "metrics",
        "iso_code": "is",
        "dont_show_length": "Ekki sýna lengd",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH",
        "special_length_rules": [{ "regex": "^(\\d*1(\\.5)?$)", "value": "SENTÍMETER" }]
	},
    "Lithuanian": {
        "scale_text": "MASTELIS 1:1",
        "date_format": "[year] M. [month] [day] D.",
        "months": ['SAUSIO', 'VASARIO', 'KOVO', 'BALANDŽIO', 'GEGUŽĖS', 'BIRŽELIO', 'LIEPOS', 'RUGPJŪČIO', 'RUGSĖJO', 'SPALIO', 'LAPKRIČIO', 'GRUODŽIO'],
        "length_unit": "CENTIMETRAI",
        "weight_unit": "GRAMAI",
        "default_unit": "metrics",
        "iso_code": "lt",
        "dont_show_length": "Nerodyti gimimo ilgio",
        "stars_over": "THE STARS ABOVE",
		"location_search": "SEARCH"
	},
    "Italian": {
        "scale_text": "SCALA 1:1 DI",
        "date_format": "[day] [month] [year]",
        "months": ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE'],
        "length_unit": "CENTIMETRI",
        "weight_unit": "GRAMMI",
        "default_unit": "metrics",
        "iso_code": "it",
        "dont_show_length": "Non mostrare la lunghezza",
        "stars_over": "Le stelle su",
		"location_search": "SEARCH"
	},
    "German": {
        "scale_text": "MAßSTAB 1:1",
        "date_format": "[day]. [month] [year]",
        "months": ['JANUAR', 'FEBRUAR', 'MÄRZ', 'APRIL', 'MAI', 'JUNI', 'JULI', 'AUGUST', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DEZEMBER'],
        "length_unit": "ZENTIMETER",
        "weight_unit": "GRAMM",
        "default_unit": "metrics",
        "iso_code": "de",
        "dont_show_length": "Länge nicht anzeigen",
        "stars_over": "DIE STERNE ÜBER",
		"location_search": "SUCHE"
	},
    "Spanish": {
        "scale_text": "ESCALA 1:1 DE",
        "date_format": "[day] DE [month] DE [year]",
        "months": ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'],
        "length_unit": "CENTÍMETROS",
        "weight_unit": "GRAMOS",
        "default_unit": "metrics",
        "iso_code": "es",
        "dont_show_length": "No mostrar longitud",
        "stars_over": "Las estrellas de arriba",
		"location_search": "SEARCH"
	},
    "Polish": {
        "scale_text": "W SKALI 1:1",
        "date_format": "[day] [month] [year]",
        "months": ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
        "length_unit": "CENTYMETRÓW",
        "weight_unit": "GRAMÓW",
        "default_unit": "metrics",
        "iso_code": "pl",
        "dont_show_length": "Nie pokazuj długości",
        "stars_over": "GWIAZDY NAD",
        "location_search": "SZUKAJ",
        "special_length_rules": [{ "regex": "\\d+\\.\\d+", "value": "CENTYMETRA" }, { "regex": "\\d*[234]\\b", "value": "CENTYMETRY" }]
    }
}

$(document).ready(function() { 
    let keys_list = Object.keys(translations);

    let languageNames = false
    try {
        languageNames = new Intl.DisplayNames([default_language], { type: "language" });
    }
    catch {
        //do nothing
    }

    const englishEntries = keys_list.filter(lang => lang.includes("English"));
    const otherLanguages = keys_list.filter(lang => !lang.includes("English"));

    // Sort Alphabetically
    otherLanguages.sort((a, b) => {
        let nameA = a;
        let nameB = b;
        if(languageNames) {
            try { 
                nameA = languageNames.of(translations[a].iso_code)
                nameB = languageNames.of(translations[b].iso_code) 
            }
            catch {}
        }
        return nameA.localeCompare(nameB);
    });

    keys_list = [...englishEntries, ...otherLanguages];

    // Bring Local Language to first
    if(typeof default_language !== "undefined") {
        keys_list.sort((a, b) => {
            // If one of the keys matches the preferred ISO code, prioritize it
            if (translations[a].iso_code === default_language) return -1;
            if (translations[b].iso_code === default_language) return 1;
          
            // Otherwise, maintain original order or use custom sorting logic
            return 0;
        });
    }

    $('.bp-language-selector-birthposter').each(function() {    
        $(this).empty();
        for (var i = 0; i < keys_list.length; i=i+1) {
            key = keys_list[i]

            let translated_name = key;
            if(languageNames) {
                try { translated_name = languageNames.of(translations[key].iso_code) }
                catch {}
            }

            $(this).append($('<option>', {
                value: `${key}`,
                text: `${translated_name}`,
                "data-iso": translations[key].iso_code,
                selected: (key == "British English") ? true : false
            }));
        }
    });

    $('.bp-language-selector-starposter').each(function() {
        $(this).empty();
        for (var i = 0; i < keys_list.length; i=i+1) {
            key = keys_list[i]

            let translated_name = key;
            if(languageNames) {
                try { translated_name = languageNames.of(translations[key].iso_code) }
                catch {}
            }

            $(this).append($('<option>', {
                value: `${key}`,
                text: `${translated_name}`,
                "data-iso": translations[key].iso_code,
                selected: (key == "British English") ? true : false
            }));
        }
    });

    $('.bp-language-selector-birthposter').on('change', function(event) {
        let lang = $(this).val();
        let details_obj = translations[lang];

        $('.bp-language-selector-birthposter').each(function() {
            $(this).val(lang);
        })

        //units work on translation
        if(lang.includes("English")) {
            $('.bp-sidebar-object:has(.bp-units-block)').removeClass('hide');
            $('.bp-time-unit').removeClass('hide');
        }
        else {
            $('.bp-sidebar-object:has(.bp-units-block)').addClass('hide');
            $('.bp-time-unit').addClass('hide');
        }
        if (event.originalEvent) {
            $('.bp-units').val(details_obj.default_unit);
            $('.bp-units').change();
            $('.bp-time-unit').val('');
            $('.bp-time-unit').change();
        }

        //scale text translation
        $('.bp-scale-text').text(details_obj.scale_text);
        if($('.bp-scale-text').length) {
            if(lang.includes("Polish")) {
                $('.bp-poster-headline').each(function() {
                    let birth_scale_text = $(this).find('.bp-scale-text');
                    let birth_name_text = $(this).find('.bp-birth-name').last();
                    birth_scale_text.insertAfter(birth_name_text);
                    birth_name_text.after(document.createTextNode(" "));
                })
            }
            else {
                $('.bp-poster-headline').each(function() {
                    let birth_scale_text = $(this).find('.bp-scale-text');
                    let birth_name_text = $(this).find('.bp-birth-name').first();
                    birth_scale_text.insertBefore(birth_name_text);
                    birth_name_text.before(document.createTextNode(" "));
                })

            }
        }

        //month translation
        $('.birth-date').attr('data-format', details_obj.date_format);
        let month_list = details_obj.months
        $('.bp-birth-month-selector option').each(function() {
            let month_index = parseInt($(this).attr('data-month')) - 1;
            $(this).val(month_list[month_index]);
            $(this).text(month_list[month_index].toUpperCase());
        });
        $('.birth-date').change();

        //weight translation
        $('.bp-weight-input').attr('data-unit', details_obj.weight_unit);
        $('.bp-weight-unit').text(details_obj.weight_unit);
        $('.bp-weight-input').change();

        //length translation
        $('.bp-birth-length-selector').attr('data-metrics', details_obj.length_unit);
        $('.bp-birth-length-selector').attr('data-no-length-translation', details_obj.dont_show_length);
        let units = $('.bp-units').val();

        if(units == "metrics")
        $('.bp-birth-length-selector').each(function() {
            let selected_val = $(this).find('option:selected').val();
            let special_rules = [];
            if(details_obj.hasOwnProperty("special_length_rules")){
                special_rules = details_obj.special_length_rules;
            }
            $(this).empty();
            for (var i = 15; i < 61.5; i=i+0.5) {
                let length = i.toString();
                let length_unit = $('.bp-birth-length-selector').attr('data-metrics');
                let individual_metric = false;
                for (let index in special_rules) {
                    const regex = new RegExp(special_rules[index].regex);
                    if(regex.test(length)) {
                        length_unit = special_rules[index].value;
                        individual_metric = true;
                        break;
                    }
                }
                let len = length;
                if(!lang.includes("English")) {
                    length = length.replace(".", ",");
                }
                $(this).append($('<option>', {
                    value: `${i}`,
                    "data-length": length,
                    text: `${length} ${length_unit}`,
                    selected: (len == selected_val) ? true : false,
                    ...(individual_metric && { "data-item-metrics": length_unit })
                }));
            }
            $(this).append($('<option>', {
                value: `51.0`,
                "data-length": 'no_length',
                text: `${$('.bp-birth-length-selector').attr('data-no-length-translation')}`,
                selected: ('51.0' == selected_val) ? true : false
            }));
            $(this).change();
        });

        //day translation formatting
        $('.bp-birth-day-selector').each(function() {
            let selected_day = $(this).find('option:selected').val();
            let index = $(this).attr('data-index');
            let current_date = $(`.birth-date[data-index="${index}"]`).val();

            let month = current_date.split("-")[1];
            let current_month_days = month_day_object[`${parseInt(month)}`];
            let date_format = $(`.birth-date[data-index="${index}"]`).attr("data-format");
            let digits = 1;
            if(date_format.includes("day_formatted")) {
                digits = 2;
            }
    
            $(this).empty();
            for (var i = 1; i <= current_month_days; i++) {
                let formatted_number = i.toLocaleString('en-US', { minimumIntegerDigits: digits, useGrouping: false });
                $(this).append($('<option>', {
                    value: `${i}`,
                    text: `${formatted_number}`
                }));
            }
            
            if($(this).find(`option[value="${selected_day}"]`).length) {
                $(this).val(selected_day);
            }
            else {
                $(this).val(1);
            }
            $(this).change();
        });
    });

    $('.bp-language-selector-starposter').on('change', function(event) {
        let lang = $(this).val();
        let details_obj = translations[lang];

        if(lang.includes("English")) {
            $('.bp-time-unit').removeClass('hide');
        }
        else {
            $('.bp-time-unit').addClass('hide');
        }
        if (event.originalEvent) {
            $('.bp-time-unit').val('');
            $('.bp-time-unit').change();
        }

        if(localStorage.getItem($('#bp-star-text1').prop("name")) === null || event.originalEvent) {
            //star over translation
            $('#bp-star-text1').val(details_obj.stars_over);
            $('#bp-star-text1').change();
        }

        //month translation
        $('.birth-date').attr('data-format', details_obj.date_format);
        let month_list = details_obj.months
        $('.bp-birth-month-selector option').each(function() {
            let month_index = parseInt($(this).attr('data-month')) - 1;
            $(this).val(month_list[month_index]);
            $(this).text(month_list[month_index].toUpperCase());
        });
        $('.birth-date').change();

        //day translation formatting
        $('.bp-birth-day-selector').each(function() {
            let selected_val = $(this).find('option:selected').val();

            $(this).empty();
            for (var i = 1; i < 32; i=i+1) {
                let digits = 1;
                if(details_obj.date_format.includes("day_formatted")) {
                    digits = 2;
                }
                
                let formatted_number = i.toLocaleString('en-US', { minimumIntegerDigits: digits, useGrouping: false });
                $(this).append($('<option>', {
                    value: `${i}`,
                    text: `${formatted_number}`,
                    selected: (`${i}` == selected_val) ? true : false
                }));
            }
            $(this).change();
        });

        let geocoder = document.querySelector('.bp-plats .bp-input-block mapbox-geocoder');
        if (geocoder) {
            geocoder.options = {
                language: details_obj.iso_code
            }
            geocoder.placeholder = details_obj.location_search
        }
    });
});